module.exports = __webpack_public_path__ + "static/media/itu-inside.c24cbc8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/itu-inside.jpg
// module id = 556
// module chunks = 0